import { createFileRoute } from '@tanstack/react-router'
import { SettingsDraftProvider, SettingsLayout } from '@/features/settings'

/** C-04: the Settings layout owns the draft, so it survives switching tabs (Frontend §6.6). */
export const Route = createFileRoute('/_authed/clinics/$clinicId/settings')({
  component: function SettingsRoute() {
    const { clinicId } = Route.useParams()
    return (
      <SettingsDraftProvider clinicId={clinicId}>
        <SettingsLayout />
      </SettingsDraftProvider>
    )
  },
})
